"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurvedLine = void 0;
const react_1 = __importDefault(require("react"));
const group_1 = require("@visx/group");
const shape_1 = require("@visx/shape");
const curve_1 = require("@visx/curve");
const marker_1 = require("@visx/marker");
const lodash_1 = require("lodash");
const getMidPoint = ({ source, target, offset }) => {
    if (source.x === target.x && source.y === target.y) {
        const x = source.x + 20;
        const y = source.y - 30;
        return [
            { x, y },
            { x: x + 40, y },
        ];
    }
    const getOffset = offset ? offset : 0;
    const x = (source.x + target.x) / 2 + getOffset;
    const y = (source.y + target.y) / 2;
    return { x, y };
};
const getAnchorPoints = (coords) => {
    const width = parseInt(coords.groupDims.width);
    const height = parseInt(coords.groupDims.height);
    const top = { x: coords.x + width / 2.2, y: coords.y };
    const bottom = { x: coords.x + width / 2, y: coords.y + height };
    const right = { x: coords.x + width, y: coords.y + height / 2 };
    const left = { x: coords.x, y: coords.y + height / 2 };
    const center = { x: coords.x + width / 2, y: coords.y + height / 2 };
    return { top, bottom, right, left, center };
};
const getCoords = ({ source, target }) => {
    const sourceAnchors = getAnchorPoints(source);
    const targetAnchors = getAnchorPoints(target);
    return { target: targetAnchors.center, source: sourceAnchors.center };
};
const getOffset = ({ source, target }) => {
    const xDiff = target.x - source.x;
    const yDiff = Math.abs(target.y - source.y);
    if (xDiff < 10) {
        return yDiff < 250 ? 50 : 40;
    }
    else if (xDiff > 10) {
        return yDiff < 150 ? 40 : 80;
    }
};
const CurvedLine = ({ source, target, lineSize = 1 }) => {
    if (!target || !source) {
        return react_1.default.createElement("div", null);
    }
    const offset = getOffset({ source, target });
    const midpoint = getMidPoint({ source, target, offset });
    const coords = getCoords({ source, target });
    const data = (0, lodash_1.flatten)([
        { x: coords.source.x, y: coords.source.y },
        midpoint,
        { x: coords.target.x, y: coords.target.y },
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(marker_1.MarkerArrow, { id: "marker-arrow", fill: "#333", refX: 3, size: 4 }),
        react_1.default.createElement(group_1.Group, null,
            react_1.default.createElement(shape_1.LinePath, { curve: curve_1.curveNatural, data: data, x: (d) => { var _a; return (_a = d.x) !== null && _a !== void 0 ? _a : 0; }, y: (d) => { var _a; return (_a = d.y) !== null && _a !== void 0 ? _a : 0; }, stroke: "#333", strokeWidth: lineSize, strokeOpacity: 1, shapeRendering: "geometricPrecision", markerMid: "url(#marker-arrow)" }))));
};
exports.CurvedLine = CurvedLine;
//# sourceMappingURL=curvedLine.js.map